var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-bar'),_c('main',{staticClass:"bd-main content"},[_c('router-view',{ref:"component"})],1),_c('Footer'),_c('Drawer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }